import { ParsedUrlQuery } from 'querystring'

export const getLoginQueryParams = (urlPathWithQuery: string): ParsedUrlQuery => {
    const paramsObject: ParsedUrlQuery = {}
    const pathAndQueryParts = urlPathWithQuery.split('?')
    pathAndQueryParts.shift()
    const decodedQueryString = decodeURIComponent(pathAndQueryParts.join(''))
    const searchParams = new URLSearchParams(decodedQueryString)

    searchParams.forEach((value, key) => {
        paramsObject[key] = value
    })

    return paramsObject
}
